import { AsyncPipe } from '@angular/common'
import { Component, effect, inject, input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { BreadcrumbItemComponent } from '../breadcrumb-item/breadcrumb-item.component'
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component'
import { Observable, Observer } from 'rxjs'
import { BreadcrumbItem } from '../breadcrumb-item/breadcrumb-item.interface'
import { BreadcrumbRouterService } from './breadcrumb-router.service'

@Component({
    selector: 'sq-breadcrumb-router',
    imports: [BreadcrumbComponent, BreadcrumbItemComponent, AsyncPipe],
    templateUrl: './breadcrumb-router.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './breadcrumb-router.component.scss',
})
export class BreadcrumbRouterComponent implements OnInit, OnDestroy {
    readonly service = inject(BreadcrumbRouterService)

    /**
     * Optional array of IBreadcrumbItem to override default BreadcrumbRouter behavior. [docs]
     * @return IBreadcrumbItem[]
     */
    readonly items = input<BreadcrumbItem[]>()
    public breadcrumbs: Observable<BreadcrumbItem[]> | undefined

    ngOnInit(): void {
        this.breadcrumbs = this.service.breadcrumbs$
    }

    readonly setup = effect(() => {
        const items = this.items()
        if (items && items.length > 0) {
            this.breadcrumbs = new Observable<BreadcrumbItem[]>((observer: Observer<BreadcrumbItem[]>) => {
                const itemsValue = this.items()
                if (itemsValue) {
                    observer.next(itemsValue)
                }
            })
        }
    })

    ngOnDestroy(): void {
        this.breadcrumbs = undefined
    }
}
